/**
 * Feature flags for the Stock Screener application
 * These can be toggled via environment variables or local overrides
 */

// Feature flag for the Charts Grid tab
export const isChartsGridEnabled = (): boolean => {
  // Check environment variable first
  if (process.env.REACT_APP_CHARTS_GRID_ENABLED !== undefined) {
    return process.env.REACT_APP_CHARTS_GRID_ENABLED === 'true';
  }
  // Default to true for development, can be set to false to disable
  return true;
};

// Feature flag for sparkline charts
export const isSparklineEnabled = (): boolean => {
  if (process.env.REACT_APP_SPARKLINE_ENABLED !== undefined) {
    return process.env.REACT_APP_SPARKLINE_ENABLED === 'true';
  }
  return true;
};

// Stale data threshold in milliseconds (30 minutes)
export const STALE_DATA_THRESHOLD_MS = 30 * 60 * 1000;

// Debounce delay for search input in milliseconds
export const SEARCH_DEBOUNCE_MS = 275;

// API request pool settings
export const MAX_CONCURRENT_REQUESTS = 5;

// Cache TTL settings
export const SPARKLINE_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
export const CHARTS_CACHE_TTL_MS = 60 * 1000; // 1 minute

// Feature flag for SEPA scoring
export const isSEPAEnabled = (): boolean => {
  if (process.env.REACT_APP_SEPA_ENABLED !== undefined) {
    return process.env.REACT_APP_SEPA_ENABLED === 'true';
  }
  return true;
};

// Feature flag for AI Analysis Panel
export const isAIAnalysisPanelEnabled = (): boolean => {
  if (process.env.REACT_APP_AI_ANALYSIS_PANEL_ENABLED !== undefined) {
    return process.env.REACT_APP_AI_ANALYSIS_PANEL_ENABLED === 'true';
  }
  return true;
};

// Feature flag for Pattern Detection
export const isPatternDetectionEnabled = (): boolean => {
  if (process.env.REACT_APP_PATTERN_DETECTION_ENABLED !== undefined) {
    return process.env.REACT_APP_PATTERN_DETECTION_ENABLED === 'true';
  }
  return true;
};

// Feature flag for Position Advisor
export const isPositionAdvisorEnabled = (): boolean => {
  if (process.env.REACT_APP_POSITION_ADVISOR_ENABLED !== undefined) {
    return process.env.REACT_APP_POSITION_ADVISOR_ENABLED === 'true';
  }
  return false; // Disabled by default until backend is ready
};

// Feature flag for in-app help center and onboarding.
export const isHelpSystemEnabled = (): boolean => {
  if (process.env.REACT_APP_ENABLE_HELP_SYSTEM !== undefined) {
    return process.env.REACT_APP_ENABLE_HELP_SYSTEM === 'true';
  }
  return true;
};
